/**
 * RYZE · THE REVIEWS SORT AS THE HOUSE LISTBOX (dev2.15-fix-pdp, 30 Oct 2026)
 * ──────────────────────────────────────────────────────────────────────────
 * THE NO NATIVE SELECT LAW (inventory row 36, the owner 2026-10-18: "never
 * the browser's or Apple's native select sheet"): Judge.me's review widget
 * 2.0 (a Vue app, client-rendered under the PDP) sorts with a native
 * <select class="jm-sort-filter__select">, so a tap on "Most Recent" opened
 * iOS's picker wheel. The app's markup cannot be restyled into a listbox, so
 * this script puts THE SORT MENU of the filter bar (ryze-facets.css
 * `.ryze-sortmenu`, the sticky bar's size menu as a popover) in its place:
 *
 *   - The native select stays where it is, painted exactly as today (the
 *     closed field: ryze-custom.css THE FILTER BOX AND THE SORT FIELD), but
 *     it is out of the pointer path (pointer-events none) and out of the tab
 *     order and the accessibility tree; a transparent button covers the same
 *     box and is the control (aria-haspopup listbox, its name = "Sort
 *     reviews: <choice>").
 *   - The button opens the house listbox, right-aligned to the field, down or
 *     up as the room allows; options 44, ink-filled + tick when picked;
 *     arrows, Home, End, Enter, Space, Escape, Tab, outside press, scroll.
 *   - A pick writes the value into the app's own select and dispatches the
 *     app's own events (input + change): Vue's v-model on a select listens to
 *     change, so the app sorts, fetches and renders exactly as before. Nothing
 *     of the app is replaced, patched or re-implemented.
 *   - Vue re-renders (a tab switch, a reload of the list) can hand back a new
 *     select: one observer on the widget re-arms whatever select appears.
 *   - Keyboard focus on the button inks the field's own border (THE ONE RING
 *     LAW, a bordered control), never a ring of its own.
 *
 * The menu's stylesheet is ryze-facets.css (the filter bar's), loaded once,
 * lazily, the first time a review sort exists on the page; every rule in it
 * is class-scoped, so it is inert on the PDP outside the menu. Nothing is
 * armed before that sheet has loaded; if it fails, nothing is armed at all
 * and the app's own select works as it always did.
 * Loaded by sections/main-product.liquid (product template only).
 */
(function () {
  'use strict';
  if (window.__ryzeJdgmSort) return;
  window.__ryzeJdgmSort = true;

  var SELECT = 'select.jm-sort-filter__select, select.jdgm-sort-dropdown';
  var me = document.currentScript;
  var CSS_URL = me ? me.getAttribute('data-menu-css') : '';
  var REDUCED = false;
  try { REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var TICK = '<svg class="ryze-sortmenu__tick" viewBox="0 0 12 12" fill="none" aria-hidden="true" focusable="false"><path d="M2.5 6.2 5 8.6l4.5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var INK = 'var(--ryze-text, #1C1812)';
  var uid = 0;
  var live = [];   /* { select, menu, ac }: a select the app throws away takes its menu and listeners with it */

  /* THE MENU'S SHEET FIRST: nothing is armed until ryze-facets.css has loaded (an unstyled menu would
     fall to the foot of <body>); if it fails, nothing is ever armed and the app's native select keeps
     working exactly as before. */
  var cssState = 'none';   /* none | loading | ready | failed */
  var cssWaiters = [];
  function sheetPresent() {
    return Array.prototype.some.call(document.styleSheets, function (sh) {
      return sh.href && sh.href.indexOf('ryze-facets.css') !== -1;
    });
  }
  function withCss(fn) {
    if (cssState === 'ready' || (cssState === 'none' && sheetPresent())) { cssState = 'ready'; fn(); return; }
    if (cssState === 'failed' || !CSS_URL) return;
    cssWaiters.push(fn);
    if (cssState === 'loading') return;
    cssState = 'loading';
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = CSS_URL;
    l.setAttribute('data-ryze-sortmenu-css', '');
    l.onload = function () {
      cssState = 'ready';
      var q = cssWaiters.splice(0);
      q.forEach(function (f) { f(); });
    };
    l.onerror = function () { cssState = 'failed'; cssWaiters.length = 0; };
    document.head.appendChild(l);
  }

  function focusQuiet(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function enhance(select) {
    if (select.__ryzeSort || select.__ryzeSortWaiting) return;
    select.__ryzeSortWaiting = true;
    withCss(function () { select.__ryzeSortWaiting = false; arm(select); });
  }

  function arm(select) {
    if (select.__ryzeSort || !select.isConnected) return;
    var box = select.parentElement;
    if (!box) return;
    select.__ryzeSort = true;
    ringStyle();
    var id = 'ryze-jdgm-sort-' + (++uid);
    var ac = ('AbortController' in window) ? new AbortController() : null;
    var on = function (target, type, fn, capture, passive) {
      var o = { capture: !!capture, passive: !!passive };
      if (ac) o.signal = ac.signal;
      target.addEventListener(type, fn, o);
    };

    /* the app's select: painted, never pressed, never focused, never announced */
    select.style.pointerEvents = 'none';
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ryze-jdgm-sort';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id);
    btn.style.cssText = 'position:absolute;inset:0;z-index:3;margin:0;padding:0;border:0;border-radius:inherit;' +
      'background:transparent;opacity:1;cursor:pointer;-webkit-appearance:none;appearance:none;' +
      '-webkit-tap-highlight-color:transparent;outline:none;color:transparent;';
    box.appendChild(btn);

    var menu = document.createElement('div');
    menu.className = 'ryze-sortmenu ryze-sortmenu--jdgm';
    menu.hidden = true;
    var list = document.createElement('div');
    list.className = 'ryze-sortmenu__panel';
    list.id = id;
    list.setAttribute('role', 'listbox');
    list.setAttribute('tabindex', '-1');
    list.setAttribute('aria-label', 'Sort reviews');
    menu.appendChild(list);
    document.body.appendChild(menu);
    live.push({ select: select, menu: menu, btn: btn, ac: ac });

    function opts() { return Array.prototype.slice.call(list.querySelectorAll('[role="option"]')); }
    function isOpen() { return menu.classList.contains('is-open'); }
    function rove(o) { opts().forEach(function (x) { x.tabIndex = x === o ? 0 : -1; }); }
    function currentLabel() {
      var o = select.options[select.selectedIndex];
      return o ? o.text.trim() : '';
    }
    function name() { btn.setAttribute('aria-label', 'Sort reviews: ' + currentLabel()); }
    function build() {
      list.textContent = '';
      Array.prototype.forEach.call(select.options, function (o) {
        if (o.disabled || o.hidden) return;
        var row = document.createElement('div');
        row.className = 'ryze-sortmenu__opt';
        row.setAttribute('role', 'option');
        row.setAttribute('data-value', o.value);
        row.setAttribute('aria-selected', o.value === select.value ? 'true' : 'false');
        row.tabIndex = -1;
        var t = document.createElement('span');
        t.textContent = o.text.trim();
        row.appendChild(t);
        row.insertAdjacentHTML('beforeend', TICK);
        list.appendChild(row);
      });
    }
    function gutter() { return window.innerWidth < 750 ? 16 : 24; }
    function place() {
      var r = select.getBoundingClientRect();
      var g = gutter();
      var w = Math.max(Math.round(r.width), 220);
      w = Math.min(w, window.innerWidth - g * 2);
      var left = Math.round(r.right - w);
      left = Math.max(g, Math.min(left, window.innerWidth - g - w));
      menu.style.width = w + 'px';
      menu.style.left = left + 'px';
      list.style.maxHeight = '';
      var h = list.scrollHeight + 2;
      var vh = window.innerHeight;
      var ceil = g;
      var hv = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ryze-head-visible-h'));
      if (!isNaN(hv)) ceil = Math.max(g, hv + 8);
      /* the phone sticky bar (z 90) owns the viewport's foot while it is up */
      var bar = document.querySelector('.ryze-sticky-atc.visible');
      var foot = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
      var below = vh - g - foot - Math.round(r.bottom + 8);
      var above = Math.round(r.top - 8) - ceil;
      var up = h > below && (h <= above || above > below);
      menu.toggleAttribute('data-up', up);
      if (up) { menu.style.top = 'auto'; menu.style.bottom = Math.round(vh - (r.top - 8)) + 'px'; }
      else { menu.style.bottom = 'auto'; menu.style.top = Math.round(r.bottom + 8) + 'px'; }
      var room = up ? above : below;
      if (h > room) list.style.maxHeight = Math.max(132, room) + 'px';
    }
    var armed = false;
    function open() {
      if (isOpen()) return;
      build();
      menu.hidden = false;
      place();
      void menu.offsetWidth;
      menu.classList.remove('is-closing');
      menu.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      var cur = list.querySelector('[aria-selected="true"]') || opts()[0];
      rove(cur);
      focusQuiet(cur);
      if (cur && list.scrollHeight > list.clientHeight) cur.scrollIntoView({ block: 'nearest' });
      armed = true;
    }
    function close(refocus) {
      if (!isOpen()) return;
      menu.classList.remove('is-open');
      menu.classList.add('is-closing');
      btn.setAttribute('aria-expanded', 'false');
      armed = false;
      setTimeout(function () {
        if (!isOpen()) { menu.classList.remove('is-closing'); menu.hidden = true; }
      }, REDUCED ? 0 : 170);
      if (refocus !== false) focusQuiet(btn);
    }
    function pick(row) {
      var v = row.getAttribute('data-value');
      close(true);
      if (select.value === v) return;
      select.value = v;
      /* the app's own events: Vue's v-model on a <select> listens to change */
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
      name();
    }

    name();
    btn.addEventListener('click', function () { if (isOpen()) close(true); else open(); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
    });
    /* THE ONE RING LAW: the field is a bordered control, so keyboard focus on the
       button inks the field's own border (plus the 0.5 px inset edge); a tap
       paints nothing (:focus-visible only) */
    btn.addEventListener('focus', function () {
      var kb = false;
      try { kb = btn.matches(':focus-visible'); } catch (e) {}
      if (!kb) return;
      select.style.setProperty('border-color', INK, 'important');
      select.style.setProperty('box-shadow', 'inset 0 0 0 0.5px ' + INK, 'important');
    });
    btn.addEventListener('blur', function () {
      select.style.removeProperty('border-color');
      select.style.removeProperty('box-shadow');
    });
    list.addEventListener('click', function (e) {
      var row = e.target.closest('[role="option"]');
      if (row) pick(row);
    });
    list.addEventListener('keydown', function (e) {
      var all = opts();
      var i = all.indexOf(document.activeElement);
      var to = null;
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(true); return; }
      /* Tab: back to the trigger without preventDefault, so the browser's own Tab
         continues from the field's place in the page (the refuter's P2-1: the
         menu lives at the foot of <body>, and Tab from it landed there) */
      if (e.key === 'Tab') { close(true); return; }
      if (e.key === 'ArrowDown') to = all[(i + 1) % all.length];
      else if (e.key === 'ArrowUp') to = all[(i - 1 + all.length) % all.length];
      else if (e.key === 'Home') to = all[0];
      else if (e.key === 'End') to = all[all.length - 1];
      else if ((e.key === 'Enter' || e.key === ' ') && i >= 0) { e.preventDefault(); pick(all[i]); return; }
      if (to) { e.preventDefault(); rove(to); focusQuiet(to); }
    });
    /* an outside press closes and is swallowed (it never presses what lies under it).
       pointerdown closes (iOS does not always send a click for a tap on plain text);
       the click that follows it, or a click with no pointer before it, is swallowed */
    var swallowUntil = 0;
    function outside(t) { return !menu.contains(t) && !btn.contains(t); }
    on(document, 'pointerdown', function (e) {
      if (!armed || !isOpen() || !outside(e.target)) return;
      swallowUntil = Date.now() + 700;
      close(false);
    }, true);
    on(document, 'click', function (e) {
      if (!outside(e.target)) return;
      if (armed && isOpen()) { e.preventDefault(); e.stopPropagation(); close(false); return; }
      if (Date.now() < swallowUntil) { swallowUntil = 0; e.preventDefault(); e.stopPropagation(); }
    }, true);
    /* focus leaving the menu (VoiceOver, a script) closes it */
    list.addEventListener('focusout', function (e) {
      var to = e.relatedTarget;
      if (!isOpen() || !to) return;
      if (list.contains(to) || to === btn) return;
      close(false);
    });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) { e.preventDefault(); close(true); }
    });
    on(window, 'scroll', function () { if (isOpen()) close(false); }, false, true);
    on(window, 'resize', function () { if (isOpen()) place(); }, false, true);
    /* the app can set its own value (a reset, a tab switch): the name follows */
    select.addEventListener('change', name);
  }

  /* THE ONE RING LAW on the picked option: an ink-filled row keyboard-focused takes
     a paper ring, not an ink ring on ink (scoped to this menu; the filter bar's
     own menu in ryze-facets.css has the same gap, its lane's) */
  var ringStyled = false;
  function ringStyle() {
    if (ringStyled) return;
    ringStyled = true;
    var st = document.createElement('style');
    st.setAttribute('data-ryze-jdgm-sort', '');
    st.textContent = ".ryze-sortmenu--jdgm .ryze-sortmenu__opt[aria-selected='true']:focus-visible" +
      '{outline-color:var(--ryze-paper,#FFFFFF);}';
    document.head.appendChild(st);
  }

  function scan(root) {
    live = live.filter(function (x) {
      if (x.select.isConnected) {
        /* the app re-rendered the field's box without our button: put it back,
           or the field (pointer-events none) would be dead to the hand */
        if (!x.btn.isConnected && x.select.parentElement) x.select.parentElement.appendChild(x.btn);
        return true;
      }
      if (x.ac) x.ac.abort();
      if (x.menu.parentNode) x.menu.parentNode.removeChild(x.menu);
      if (x.btn.parentNode) x.btn.parentNode.removeChild(x.btn);
      return false;
    });
    Array.prototype.forEach.call((root || document).querySelectorAll(SELECT), enhance);
  }

  /* the widget renders late and re-renders: one observer, one scan per frame */
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; scan(document); });
  }
  function boot() {
    scan(document);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes && records[i].addedNodes.length) { queue(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
